<template>
  <div class="item-card" @click="clickHandler">
    <div class="entry" style="width:145px">{{ item.createdAt }}</div>
    <div class="entry" style="width:70px">{{ item.id }}</div>
    <div class="entry" style="width:195px">{{ item.name }}</div>
    <div class="entry" style="width:300px">{{ item.description }}</div>
  </div>
</template>

<script setup>
import { defineEmits } from 'vue';

const emit = defineEmits(['clicked']);
const props = defineProps({ item: {} });

function clickHandler() {
  emit('clicked', props.item);
}

</script>

<style lang="scss" scoped>

.item-card {
  margin-top: 4px;
  padding: 2px 8px 2px 8px;
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  gap: 12px;
  flex-wrap: wrap;
  border: 1px solid rgb(220, 217, 217);
  cursor: pointer;
}

.item-card:hover {
  background-color: rgb(214, 214, 211);
}

.entry {
  font-size: small;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>
